
export default class ExtendedRoute {
    constructor (
        lat,
        lng,
        rawLat,
        rawLng,
        matchDistance,
        confidenceValue,
        headingMatched,
        distanceToRaw,
        speedInKph,
        speeding,
        address,
        speedLimitInKph,
        UTC,
        speedLimit
    ) {
        this.lat = lat
        this.lng = lng
        this.rawLat = rawLat
        this.rawLng = rawLng
        this.matchDistance = matchDistance
        this.confidenceValue = confidenceValue
        this.headingMatched = headingMatched
        this.distanceToRaw = distanceToRaw
        this.speedInKph = speedInKph
        this.speeding = speeding
        this.address = address
        this.speedLimitInKph = speedLimitInKph
        this.UTC = UTC
        this.speedLimit = speedLimit
    }
}
